export default "__VITE_ASSET__57b51252__"